// removed by extract-text-webpack-plugin
module.exports = {"Container":"src-components-QRcode-__QRLabel-module___Container","Title":"src-components-QRcode-__QRLabel-module___Title","QRcode":"src-components-QRcode-__QRLabel-module___QRcode","Content":"src-components-QRcode-__QRLabel-module___Content","Edit":"src-components-QRcode-__QRLabel-module___Edit","Delete":"src-components-QRcode-__QRLabel-module___Delete","Icon":"src-components-QRcode-__QRLabel-module___Icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QRcode/QRLabel.module.css
// module id = 1248
// module chunks = 1